import { Route, RouteItems } from 'types/route-types';
import { capitalize } from 'helpers/utils';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FeatherIcon from 'feather-icons-react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import Badge from 'components/base/Badge';

interface TopNavMegaMenuProps {
  route: RouteItems;
}

const TopNavMegaMenu = ({ route }: TopNavMegaMenuProps) => {
  return (
    <Nav className="dropdown-menu mega-menu">
      <div className="row g-0">
        <div className="col-12">
          <div className="row g-0">
            {route.pages?.map((page, index) => (
              <div key={index} className="col-12 col-sm-6 col-xl-3">
                <div className="mega-menu-item">
                  <h6 className="text-uppercase text-body-tertiary fw-bold fs-10 mb-3">
                    {capitalize(page.name)}
                  </h6>
                  {page.pages?.map((subPage, subIndex) => (
                    <NavLink
                      key={subIndex}
                      to={subPage.path ? subPage.path : '#!'}
                      className={({ isActive }) =>
                        classNames('nav-link', {
                          active: isActive && subPage.path !== '#!'
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        {subPage.icon && (
                          <span className="nav-link-icon">
                            {typeof subPage.icon === 'string' ? (
                              <FeatherIcon icon={subPage.icon} size={16} />
                            ) : (
                              <FontAwesomeIcon
                                icon={subPage.icon as IconProp}
                                transform={{ size: 16 }}
                              />
                            )}
                          </span>
                        )}
                        <span className="nav-link-text">{capitalize(subPage.name)}</span>
                        {subPage.new && (
                          <Badge variant="phoenix" bg="info" className="ms-2">
                            New
                          </Badge>
                        )}
                      </div>
                    </NavLink>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Nav>
  );
};

export default TopNavMegaMenu;
